import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

import EmailDialog from './EmailDialog';
import PasswordDialog from './PasswordDialog';

const AccessDetailsCard = ({ email = '' }) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle className="text-lg">Access details</CardTitle>
        <CardDescription>Your email and password for signing in.</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className="font-semibold w-[190px]">Email</TableCell>
              <TableCell className="w-[85px]">:</TableCell>
              <TableCell>{email}</TableCell>
              <TableCell className="w-[109px]">
                <EmailDialog email={email} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold w-[190px]">Password</TableCell>
              <TableCell className="w-[85px]">:</TableCell>
              <TableCell>**********</TableCell>
              <TableCell className="w-[109px]">
                <PasswordDialog />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default AccessDetailsCard;
